import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../Global/axios";
import { sortByName } from "../../utils/sortByName";

const getProjectData = createAsyncThunk("api/project", async (token) => {
  try {
    const response = await axios.get("/dashboard/project", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  } catch (e) {
    throw new Error(e.message);
  }
});

const ProjectDataSlice = createSlice({
  name: "Project",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProjectData.fulfilled, (state, action) => {
        state.data = sortByName(action.payload);
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getProjectData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getProjectData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getProjectData };
export default ProjectDataSlice.reducer;
